import clsx from "clsx";
import moment from "moment";
import { Button } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { BsCalculator, BsCalendar3 } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AiOutlineApi,
  AiOutlineDelete,
  AiOutlineInfoCircle,
} from "react-icons/ai";
import { useCallback, useEffect, useMemo, useState, ReactNode } from "react";
import {
  DollarCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Col,
  Collapse,
  DatePicker,
  Descriptions,
  Divider,
  List,
  message,
  Modal,
  Row,
  Skeleton,
  Space,
  Spin,
  Tooltip,
  Typography,
} from "antd";
import { Container, Content } from "./styles";
import { PayTags } from "./Components/PayTags";
import { Page } from "../../constants/brokers";
import AntButton from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import { FormModal } from "../../components/FormModal";
import { apiPayment } from "../../services/apiPayment";
import { StyledTag } from "./Components/PayTags/styles";
import { useBroker } from "../../contexts/BrokerContext";
import apis, { NOT_AUTHORIZED } from "../../services/apis";
import { PaymentModal } from "../../components/PaymentModal";
import { IntegrationModal } from "./Components/IntegrationModal";
import { DatePickerExtraFooter } from "./Components/DatePickerExtraFooter";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import {
  DatePickerMonthCell,
  YearResume,
} from "./Components/DatePickerMonthCell";
import {
  antDatePickerLocale,
  download,
  errorMessage,
  formatCurrency,
  getZeroBuyPrice,
  monthsExtended,
} from "../../utils";
import {
  DarfResultDescriptions,
  DarfFormItemRows,
  defaultDarf,
  DarfModal,
  IDarf,
  DarfImpostosDevidosDescriptions,
  minDarfPrice,
  maxDarfPrice,
  YearResumeStatusFromBackEnum,
  YearResumeStatusCSSClassEnum,
  YearResumeStatusTextEnum,
  YearResumeStatusColorEnum,
} from "../../constants/darf";
import HandleTag from "../../services/handleTag";
import { ModalZeroBuyPrice } from "../../components/ModalZeroBuyPrice";

interface DarfProps {
  item: Page;
  view?: boolean;
  darf?: {
    id: string;
  };
}

export const Darf: React.FC<DarfProps> = ({ item, view, darf }) => {
  const { user, updateUserInfo } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { currentBroker, currentPage } = useBroker();
  const today = new Date();
  const queryYear = (state as any)?.year;
  const queryMonth = (state as any)?.month;
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const maxPixPayment = 10000;
  const maxCreditCardPayment = 10000;

  const initialMonth = queryMonth
    ? queryMonth - 1
    : today.getMonth() - 1 >= 0
    ? today.getMonth() - 1
    : 11;
  const initialYear = queryYear
    ? queryYear
    : today.getMonth() - 1 >= 0
    ? today.getFullYear()
    : today.getFullYear() - 1;
  const defaultValue = moment({ month: initialMonth, year: initialYear });
  const currentDate = moment({
    month: currentMonth,
    year: currentYear,
  }).subtract(1, "M");
  window.history.replaceState({}, document.title);

  const [asset, setAsset] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [emitting, setEmitting] = useState(false);
  const [darfModal, setDarfModal] = useState<any>();
  const [helpModal, setHelpModal] = useState<any>();
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState<IDarf>();
  const [year, setYear] = useState(initialYear);
  const [month, setMonth] = useState(initialMonth);
  const [data, setData] = useState<IDarf>(defaultDarf);
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [yearResume, setYearResume] = useState<YearResume[]>([]);
  const [gettingYearResume, setGettingYearResume] = useState(false);
  const [notAuthorized, setNotAuthorized] = useState(false);
  const [showNotAuthorizedModal, setShowNotAuthorizedModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [ignoreZeroBuyPrice, setIgnoreZeroBuyPrice] = useState(false);
  const [dataZeroBuyPrice, setDataZeroBuyPrice] = useState<any[]>([]);
  const [modalZeroBuyPrice, setModalZeroBuyPrice] = useState(false);

  const transactionFeature = item.features[0];
  const taxFeature = item.features[1];
  const yearResumeFeature = item.features[2];

  // const userPlanInfoStatus = useMemo(
  //   () => user.user.userPlanInfoVelotax,
  //   [user.user.userPlanInfoVelotax]
  // );

  const { emitted, status } = useMemo(() => {
    if (gettingYearResume) {
    }
    const monthResume = yearResume
      .find((resume) => resume.year === year)
      ?.months.find((m) => m.month - 1 === month);
    return {
      emitted:
        monthResume?.status === YearResumeStatusFromBackEnum.PAYED ||
        monthResume?.status === YearResumeStatusFromBackEnum.NOT_PAYED,
      payed: !!monthResume?.payed,
      status: monthResume?.status,
    };
  }, [yearResume, year, month, gettingYearResume]);

  const getDarf = useCallback(
    (id: string) => {
      view && setLoading(true);
      view &&
        (currentPage?.api || apis)
          .get(`${taxFeature.apiUrl}/${id}`)
          .then((response) => {
            setYear(response.data?.year);
            setMonth(response.data?.month - 1);
            setData({
              ...response.data,
              emitted: true,
            });
          })
          .catch(() => message.error(errorMessage))
          .finally(() => setLoading(false));
    },
    [view, taxFeature.apiUrl, currentPage]
  );

  const getYearResume = useCallback(
    (year: number, force?: boolean, url?: string) => {
      setGettingYearResume(true);
      !view &&
        year <= new Date().getFullYear() &&
        year >= currentBroker.initialYear &&
        (force ||
          (!yearResumeFeature.disabled &&
            !yearResume.find((resume) => resume.year === year))) &&
        (currentPage?.api || apis)
          .get(yearResumeFeature.apiUrl, { params: { year } })
          .then((response) => {
            const index = yearResume.findIndex(
              (resume) => resume.year === year
            );
            if (index >= 0) {
              setYearResume((yearResume) => {
                yearResume.splice(index, 1, response.data);
                return yearResume;
              });
            } else {
              setYearResume((yearResume) => [...yearResume, response.data]);
            }

            if (url) {
              download(url);
            }
          })
          .catch((err) => console.log(err))
          .finally(() => setGettingYearResume(false));
    },
    [
      yearResumeFeature,
      yearResume,
      view,
      currentBroker.initialYear,
      currentPage,
    ]
  );

  const getTaxes = useCallback(() => {
    !view && setLoading(true);
    !view &&
      (currentPage?.api || apis)
        .get(transactionFeature.apiUrl, { params: { month: month + 1, year } })
        .then((response) => {
          setData(response.data);
          setNotAuthorized(false);
        })
        .catch((err) => {
          setData(defaultDarf);
          if (err?.response?.data === NOT_AUTHORIZED) {
            setNotAuthorized(true);
            setShowNotAuthorizedModal(true);
          } else {
            setNotAuthorized(false);
            message.error(errorMessage);
          }
        })
        .finally(() => setLoading(false));
  }, [view, currentPage?.api, transactionFeature.apiUrl, month, year]);

  const handleDarf = (justSave?: boolean) => {
    setEmitting(true);
    onCloseDarfModal();
    (currentPage?.api || apis)
      .post(taxFeature.apiUrl, {
        ...data,
        year,
        month: month + 1,
        name: user.user.name,
        memoriaCalculo: [],
        transactions: data.memoriaCalculo,
        paymentInfo: {
          clientInfo: {
            name: user?.user?.name,
            email: user?.user?.email,
            document: user?.user?.cpf,
          },
        },
        insertPix: true,
        justSave,
      })
      .then((res) => {
        setData((data) => ({ ...data, emitted: true }));
        getYearResume(year, true, justSave ? "" : res.data.darfUrl);
        setEmitting(false);
        message.success("O DARF foi enviado para o seu e-mail");
        handleNavigateToHistoric();
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || errorMessage);
        setEmitting(false);
      });
  };

  const handleRegularize = (regular: boolean) => {
    setEmitting(true);
    (currentPage?.api || apis)
      .post("transaction/regularize", {
        year,
        month: month + 1,
        regular,
        impostoDevido: data.impostoDevido,
        totalImpostoDevido: data.totalImpostoDevido,
      })
      .then((res) => {
        getYearResume(year, true, res.data.darfUrl);
        getTaxes();
        message.success("Dados salvos");
        handleNavigateToHistoric();
      })
      .catch(() => message.error(errorMessage))
      .finally(() => setEmitting(false));
  };

  const onChangeMonth = (value: moment.Moment | null, dateString: string) => {
    const [month, year] = dateString.split("-");
    setMonth(parseInt(month) - 1);
    setYear(parseInt(year));
  };

  const unsetAsset = () => {
    setAsset(undefined);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    unsetAsset();
  };

  const handleCloseAssetModal = () => {
    setShowAssetModal(false);
    unsetAsset();
  };

  const onCloseHelpModal = () => {
    setHelpModal(undefined);
  };

  const onCloseDarfModal = () => {
    setDarfModal(undefined);
  };

  const handleOpenDarfModal = () => {
    setDarfModal(DarfModal(emitted, onCloseDarfModal, () => handleDarf()));
  };

  const handleOpenPaymentModal = () => {
    setPaymentModal(!paymentModal);
  };

  const handleAdd = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    setShowAssetModal(true);
  };

  const handleEdit = (item: any, index: number) => {
    setShowAssetModal(true);
    setAsset({
      ...item,
      data: moment.utc(item.data.toLocaleString()).format("DD/MM/YYYY"),
      dataVenda: moment
        .utc(item?.dataVenda?.toLocaleString())
        ?.format("DD/MM/YYYY"),
      dataCompra: moment
        .utc(item?.dataCompra?.toLocaleString())
        ?.format("DD/MM/YYYY"),
    });
  };

  const handleRemove = (item: any, index: number) => {
    setShowDeleteModal(true);
    setAsset(item);
  };

  const addAsset = (asset: any) => {
    setLoading(true);
    (currentPage?.api || apis)
      .post(`${transactionFeature.apiUrl}?manual=true`, asset, {
        headers: {
          "x-email": user.user.email,
        },
      })
      .then(() => {
        getTaxes();
        getYearResume(year, true);
      })
      .catch(() => message.error(errorMessage))
      .finally(() => {
        setLoading(false);
        handleCloseAssetModal();
      });
  };

  const editAsset = (data: any) => {
    setLoading(true);
    (currentPage?.api || apis)
      .put(`${transactionFeature.apiUrl}/${data.id}`, data)
      .then(() => {
        getTaxes();
        getYearResume(year, true);
      })
      .catch(() => message.error(errorMessage))
      .finally(() => {
        setLoading(false);
        handleCloseAssetModal();
      });
  };

  const removeAsset = () => {
    setLoading(true);
    (currentPage?.api || apis)
      .delete(`${transactionFeature.apiUrl}/${asset.id}`)
      .then(() => {
        getTaxes();
        getYearResume(year, true);
      })
      .catch(() => message.error(errorMessage))
      .finally(() => {
        setLoading(false);
        handleCloseDeleteModal();
      });
  };

  useEffect(()=> {
    if (ignoreZeroBuyPrice) handleEventDarfButton();
  }, [ignoreZeroBuyPrice])
  // const handlePlanModal = () => {
  //   showUserPlanModal(!userPlanModal);
  // };
  const handleEventDarfButton = async () => {
    // !userPlanInfoStatus.active && !userPlanInfoStatus.actionFree
    // ? handlePlanModal()

    if (!ignoreZeroBuyPrice) {
      const hasZeroBuyPrice = await getZeroBuyPrice(data?.memoriaCalculo);
      if (hasZeroBuyPrice.length > 0) {
        setModalZeroBuyPrice(true);
        setDataZeroBuyPrice(hasZeroBuyPrice);
        return;
      }
    }

    handleOpenPaymentModal();
  };

  // const handleSaveMonth = async () => {
  //   try {
  //     handleDarf(true)
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleLabelButton: ReactNode = useMemo(() => {
    // if (!userPlanInfoStatus) return "Assinar Plano Emissão de DARF";

    if (data?.totalImpostoDevido <= maxDarfPrice) return "Pagar DARF";
    else {
      if (emitted) return "Emitir novo DARF";
      else return taxFeature?.buttonLabel;
    }
  }, [data?.totalImpostoDevido, emitted, taxFeature?.buttonLabel]);

  const handleNavigateToHistoric = () => {
    navigate(
      item.settings?.historicUrl ?? `/${currentBroker.path}/cripto-historic`,
      {
        state: { year },
      }
    );
  };

  const handleNavigateToIntegration = () => {
    navigate(
      item.settings?.integrationUrl ?? `/${currentBroker.path}/integration`
    );
  };

  useEffect(() => {
    getTaxes();
  }, [getTaxes, month, year]);

  useEffect(() => {
    if (view && darf) {
      getDarf(darf.id);
    }
  }, [getDarf, view, darf]);

  useEffect(() => {
    getYearResume(year);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const dataToPayment = {
      ...data,
      year,
      month: month + 1,
      name: user.user.name,
      memoriaCalculo: [],
      transactions: data.memoriaCalculo,
    };

    setPaymentData(dataToPayment);
  }, [data.totalImpostoDevido, data, month, user.user.name, year]);

  const PendingValueCustodyTransferModal = {
    title: "Custo de compra pendente",
    content: (
      <div>
        <p>
          Preencha os valores da aba{" "}
          <span
            style={{ color: "#549CFF", cursor: "pointer" }}
            onClick={() => navigate("/mynt/transferencia-custodia")}
          >
            Transferência de custódia
          </span>
          .
        </p>
      </div>
    ),
  };

  return (
    <Container className={clsx({ view })}>
      <Modal
        footer={null}
        visible={warningModal}
        title={PendingValueCustodyTransferModal.title}
        onCancel={() => setWarningModal(false)}
      >
        {PendingValueCustodyTransferModal.content}
      </Modal>
      {!view && <Typography.Title level={1}>Emita o seu DARF</Typography.Title>}
      <Content className={clsx({ view })}>
        <Space direction="vertical" className="full-width">
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={16}>
              <Typography.Title level={3}>
                <BsCalendar3 />
                {monthsExtended[month]} de {year}
              </Typography.Title>
            </Col>
            {!view && (
              <>
                <Col
                  xs={
                    false && item.settings?.showNavigateToIntegrationButton
                      ? 20
                      : 24
                  }
                  sm={
                    false && item.settings?.showNavigateToIntegrationButton
                      ? 6
                      : 8
                  }
                >
                  <DatePicker
                    size="large"
                    picker="month"
                    format="MM-YYYY"
                    disabled={loading}
                    allowClear={false}
                    inputReadOnly={true}
                    onChange={onChangeMonth}
                    suffixIcon={<BsCalendar3 />}
                    defaultValue={defaultValue}
                    locale={antDatePickerLocale}
                    onPanelChange={(e) => getYearResume(e.year())}
                    getPopupContainer={(target) => target.parentElement!}
                    renderExtraFooter={() =>
                      yearResumeFeature.disabled ? (
                        <></>
                      ) : (
                        <DatePickerExtraFooter />
                      )
                    }
                    disabledDate={(current) =>
                      current &&
                      (current > currentDate.endOf("month") ||
                        current <
                          moment(`${currentBroker.initialYear}-01-01`) ||
                        current < moment(`2020-01-01`))
                    }
                    monthCellRender={(e) => (
                      <DatePickerMonthCell event={e} yearResume={yearResume} />
                    )}
                  />
                </Col>
                {false && item.settings?.showNavigateToIntegrationButton && (
                  <Col xs={4} sm={2}>
                    <Tooltip title="Ir para integrações">
                      <AntButton
                        size="large"
                        type="primary"
                        icon={<AiOutlineApi />}
                        onClick={handleNavigateToIntegration}
                      />
                    </Tooltip>
                  </Col>
                )}
              </>
            )}
            {!view && !notAuthorized && status && (
              <>
                <Typography.Text strong style={{ margin: "0 8px" }}>
                  Situação:
                </Typography.Text>
                <StyledTag
                  className={YearResumeStatusCSSClassEnum[status]}
                  title={YearResumeStatusTextEnum[status]}
                  color={YearResumeStatusColorEnum[status]}
                >
                  {YearResumeStatusTextEnum[status]}
                </StyledTag>
              </>
            )}
            {view && data?.emitted && (
              <Col span={24}>
                <PayTags payed={!!data.payed} />
              </Col>
            )}
          </Row>

          <br />

          <Descriptions size="small" bordered column={1}>
            {DarfImpostosDevidosDescriptions.map((description) => (
              <Descriptions.Item
                key={description.id}
                label={description.label(setHelpModal)}
              >
                {loading ? (
                  <Spin />
                ) : description.render ? (
                  description.render(data, view)
                ) : (
                  formatCurrency(
                    Number(data[description.id as keyof IDarf] || 0)
                  )
                )}
              </Descriptions.Item>
            ))}
          </Descriptions>

          <br />

          <Collapse
            ghost
            bordered={false}
            defaultActiveKey={["1"]}
            expandIconPosition="right"
          >
            <Collapse.Panel
              key="1"
              header={
                <Typography.Title level={3}>
                  <BsCalculator />
                  Histórico de vendas
                </Typography.Title>
              }
            >
              {!notAuthorized && !view && (
                <Button
                  className="add"
                  color="secondary"
                  variant="contained"
                  disabled={loading}
                  onClick={handleAdd}
                  startIcon={<PlusOutlined />}
                >
                  Adicionar
                </Button>
              )}
              <List
                loading={loading}
                itemLayout="horizontal"
                dataSource={data.memoriaCalculo}
                renderItem={(item, index) => {
                  return (
                    <List.Item
                      actions={
                        notAuthorized || view
                          ? []
                          : [
                              item.custody && (
                                <>
                                  <AntButton
                                    type="text"
                                    onClick={() => setWarningModal(true)}
                                    icon={
                                      <AiOutlineInfoCircle
                                        className="alert-icon"
                                        size={20}
                                      />
                                    }
                                  />
                                </>
                              ),
                              <AntButton
                                type="text"
                                onClick={() => handleEdit(item, index)}
                                icon={<FaRegEdit size={18} />}
                              />,
                              <AntButton
                                type="text"
                                onClick={() => handleRemove(item, index)}
                                icon={<AiOutlineDelete size={18} />}
                              />,
                            ]
                      }
                    >
                      <Skeleton title={false} loading={item.loading} active>
                        <List.Item.Meta
                          title={<strong>{item.ativo}</strong>}
                          description={
                            <div className="list-description">
                              <div>
                                Data:{" "}
                                {moment
                                  .utc(item?.data?.toLocaleString())
                                  .format("DD/MM/YYYY")}
                              </div>
                              <div>
                                Ganho:{" "}
                                <strong>
                                  {formatCurrency(
                                    item.ganho ??
                                      item.quantidade *
                                        (item.precoVenda - item.custoCompra) -
                                        item.taxas ??
                                      0
                                  )}
                                </strong>
                              </div>
                              {item.quantidade && (
                                <div>Quantidade: {item.quantidade}</div>
                              )}
                              {view && (
                                <>
                                  <div>
                                    Valor de Venda:{" "}
                                    <strong>
                                      {formatCurrency(item.precoVenda)}
                                    </strong>
                                  </div>
                                  <div>
                                    Valor de Compra:{" "}
                                    <strong>
                                      {formatCurrency(item.custoCompra)}
                                    </strong>
                                  </div>
                                  <div>
                                    Taxas:{" "}
                                    <strong>
                                      {formatCurrency(item.taxas)}
                                    </strong>
                                  </div>
                                </>
                              )}
                            </div>
                          }
                        />
                      </Skeleton>
                    </List.Item>
                  );
                }}
              />
            </Collapse.Panel>
          </Collapse>

          <br />

          <Collapse
            ghost
            bordered={false}
            defaultActiveKey={["1"]}
            expandIconPosition="right"
          >
            <Collapse.Panel
              key="1"
              header={
                <div className="total-tax-header">
                  <Typography.Title level={3}>
                    <DollarCircleOutlined />
                    Imposto total
                  </Typography.Title>
                  <Typography.Title level={3} className="text-center">
                    {loading ? (
                      <Spin style={{ marginRight: "32px" }} />
                    ) : (
                      formatCurrency(
                        !view
                          ? data.impostoDevido +
                              data.impostoAcumulado +
                              (data.impostoDevido + data.impostoAcumulado <
                              minDarfPrice
                                ? 0
                                : data.multa + data.juros)
                          : Math.max(
                              (data.impostoDevido || 0) +
                                (data.impostoAcumulado || 0) +
                                ((data.impostoDevido || 0) +
                                  (data.impostoAcumulado || 0) <
                                minDarfPrice
                                  ? 0
                                  : data.multa + data.juros),
                              0
                            )
                      )
                    )}
                  </Typography.Title>
                </div>
              }
            >
              <Descriptions size="small" bordered column={1}>
                {DarfResultDescriptions.map((description, i) => (
                  <Descriptions.Item
                    key={description.id}
                    label={description.label(setHelpModal)}
                    style={{
                      display: i === 3 ? "none" : "table-cell",
                    }}
                  >
                    {loading ? (
                      <Spin />
                    ) : description.Component ? (
                      <description.Component
                        data={data}
                        year={year}
                        month={month}
                        loading={loading}
                        setDataCripto={setData}
                        url={transactionFeature.apiUrl}
                        disabled={!notAuthorized && !view}
                        view={view}
                      />
                    ) : (
                      formatCurrency(
                        Number(data[description.id as keyof IDarf] || 0)
                      )
                    )}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Collapse.Panel>
          </Collapse>
        </Space>
        {!notAuthorized && !view && (
          <>
            <Divider />
            <Row justify="end" className="darf-action-buttons column-reverse">
              <Col xs={24} sm={12}>
                <Button
                  fullWidth
                  size="large"
                  color="inherit"
                  variant="contained"
                  disabled={loading || emitting}
                  onClick={handleNavigateToHistoric}
                >
                  Ver no histórico
                </Button>
              </Col>
              {(data?.impostoDevido + data?.impostoAcumulado || 0) <
                minDarfPrice && (
                <Col xs={24} sm={12}>
                  <Tooltip
                    title={
                      <>
                        O valor do imposto devido é menor que{" "}
                        {formatCurrency(minDarfPrice)}. Você não precisa emitir
                        um DARF para este mês. Clique aqui para regularizar este
                        mês.
                      </>
                    }
                  >
                    <Button
                      fullWidth
                      size="large"
                      color="secondary"
                      variant="contained"
                      startIcon={emitting && <LoadingOutlined />}
                      disabled={
                        loading ||
                        emitting ||
                        (month === currentMonth && year === currentYear)
                      }
                      onClick={() => {
                        // if (!userPlanInfoStatus) {
                        //   handlePlanModal();
                        //   return;
                        // }

                        handleRegularize(true);
                      }}
                    >
                      Salvar sem emitir DARF
                    </Button>
                  </Tooltip>
                </Col>
              )}
              {data.impostoDevido + data.impostoAcumulado >= minDarfPrice && (
                <Col xs={24} sm={12}>
                  <Button
                    fullWidth
                    size="large"
                    color="secondary"
                    variant="contained"
                    startIcon={emitting && <LoadingOutlined />}
                    disabled={
                      loading ||
                      emitting ||
                      (month === currentMonth && year === currentYear)
                    }
                    onClick={
                      // data.totalImpostoDevido <= maxDarfPrice
                      //   ? handleOpenPaymentModal
                      //   : handleOpenDarfModal
                      () => {
                        HandleTag("92");
                        handleEventDarfButton();
                      }
                    }
                  >
                    {/* {data.totalImpostoDevido <= maxDarfPrice
                    ? "Pagar DARF"
                    : emitted
                    ? "Emitir novo DARF"
                  : taxFeature.buttonLabel} */}
                    {handleLabelButton}
                  </Button>
                </Col>
              )}
            </Row>
            {/* {data.impostoDevido + data.impostoAcumulado >= minDarfPrice && (
              <Row
                gutter={[16, 16]}
                justify="end"
                align="middle"
                style={{ marginTop: "16px" }}
              >
                <Col>
                  {
                    loading || emitting
                      ?
                    <span
                      style={{ fontSize: '16px', pointerEvents: 'none'}}
                    >
                      Salvar apenas
                    </span>
                      :
                    <Button
                      style={{ fontSize: '13px', color: 'var(--ant-primary-color)'}}
                      color="secondary"
                      onClick={handleSaveMonth}
                    >
                      Salvar apenas
                    </Button>
                  }

                </Col>
              </Row>
            )} */}
          </>
        )}
      </Content>
      <Modal
        footer={null}
        visible={helpModal}
        title={helpModal?.title}
        onCancel={onCloseHelpModal}
      >
        {helpModal?.content}
      </Modal>
      <Modal
        visible={darfModal}
        title={darfModal?.title}
        footer={darfModal?.footer}
        onCancel={onCloseDarfModal}
        zIndex={1001}
      >
        {darfModal?.content}
      </Modal>
      <FormModal
        loading={loading}
        add={addAsset}
        edit={editAsset}
        itemToEdit={asset}
        visibility={showAssetModal}
        onCancel={handleCloseAssetModal}
        rows={DarfFormItemRows(month, year)}
        title={asset ? "Editar ativo" : "Adicionar ativo"}
        footerChildren={
          <Typography
            style={{
              margin: "16px 0 0",
              textAlign: "justify",
              color: "var(--velotax-font-color-dark)",
            }}
          >
            O Usuário é exclusivamente responsável pela conferência e validação
            das informações utilizadas na apuração do imposto devido, conforme{" "}
            <a href="https://velotax-termos-e-condicoes.s3.us-east-1.amazonaws.com/Termos%20de%20Uso%20-%20Velotax%20v1.pdf">
              Termos e Condições Gerais de Uso.
            </a>
          </Typography>
        }
      />
      <PaymentModal
        item={item}
        show={paymentModal}
        emitting={emitting}
        disablePixOption={data?.totalImpostoDevido > maxPixPayment}
        disableCreditCardOption={
          data?.totalImpostoDevido > maxCreditCardPayment
        }
        onCancel={handleOpenPaymentModal}
        paymentData={{
          ...paymentData,
          impostoTotalFinal: data.totalImpostoDevido + data.impostoAcumulado,
        }}
        callDarf={() => {
          HandleTag("94");
          handleOpenDarfModal();
        }}
        maxPixValue={maxPixPayment}
        maxCCValue={maxCreditCardPayment}
        selectedYear={year}
      />
      <DeleteConfirmationModal
        title="Remover ativo"
        visibility={showDeleteModal}
        onCancel={handleCloseDeleteModal}
        setVisibility={setShowDeleteModal}
        onOk={() => Promise.resolve(removeAsset())}
        body="Você realmente quer deletar esse ativo?"
      />
      {!view && (
        <>
          <IntegrationModal
            visible={showNotAuthorizedModal}
            onCancel={() => setShowNotAuthorizedModal(false)}
          />
          <div className="juridic-messages-container">
            <div className="message">
              <p>
                (1) Os cálculos de imposto de renda foram realizados levando em
                consideração somente as operações de compra e venda realizadas
                na Mynt. Caso você tenha realizado operações com criptoativos em
                outras corretoras, realize as alterações manualmente.
              </p>
            </div>
            <div className="message">
              <p>
                (2) O Usuário é exclusivamente responsável pela conferência e
                validação das informações utilizadas na apuração do imposto
                devido, conforme{" "}
                <a href="https://velotax-termos-e-condicoes.s3.us-east-1.amazonaws.com/Termos%20de%20Uso%20-%20Velotax%20v1.pdf">
                  Termos e Condições Gerais de Uso.
                </a>
              </p>
            </div>
          </div>
        </>
      )}
      <ModalZeroBuyPrice
        visible={modalZeroBuyPrice}
        title={'Atenção'}
        dataZeroBuyPrice={dataZeroBuyPrice}
        setIgnoreZeroBuyPrice={setIgnoreZeroBuyPrice}
        setModalZeroBuyPrice={setModalZeroBuyPrice}
      >
      </ModalZeroBuyPrice>
    </Container>
  );
};
